/* eslint-disable no-restricted-globals */

/**
 * Determines if a given value is a valid number.
 * @param {any} value The value to check if it's a number.
 *
 * @returns {boolean} True if the value is a valid number, false otherwise.
 * @example
 * isNumeric(42) // returns true
 * isNumeric("42") // returns true
 * isNumeric("42.42") // returns true
 * isNumeric("not a number") // returns false
 */
export default function isNumeric(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
}
